import React from 'react'
import styles from './Letter.module.css'

const Letter = props => {
  let letterClass = styles.Letter
  if (props.clickedLetter) {
    letterClass = styles.Clicked
    if (props.correctGuess) {
      letterClass = styles.Correct
    }
  } 
  
  return (
    <div 
      className={letterClass}
      onClick={() => props.clicked(props.letterIndex)}
    >
      {props.letter}
    </div>
  )
}

export default Letter